import lodash from "lodash";

function isNumeric(str) {
	if (typeof str != "string") return false; // we only process strings!
	return (
		!isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
		!isNaN(parseFloat(str))
	); // ...and ensure strings of whitespace fail
}

export function processAttributes(attributes) {
	Object.keys(attributes).forEach((key) => {
		let value = attributes[key];

		// console.log(key, value, typeof value);
		if (lodash.lowerCase(value) === "false") value = false;
		if (lodash.lowerCase(value) === "true") value = true;
		if (isNumeric(value)) value = lodash.parseInt(value);
		if (value === "") value = undefined;

		// console.log(key, value, typeof value);
		attributes[key] = value;
	});

	if (attributes.filtertags) attributes.filterTags = attributes.filtertags;

	return attributes;
}
